<form [ngClass]="{'form-previously-submitted' : targetFormSubmitted}">
  <header class="info-tile-alt heading-row">
    <!-- <div *ngIf="drawName?.length > 10" tooltip="{{drawName}}" offset="0" zIndex="20000" placement="bottom"
             class="title-container">
            <h2>Assign projects for {{drawName.substring(0, 10)}}...</h2>
        </div> -->
    <div tooltip="{{drawName}}" offset="0" zIndex="20000" placement="bottom" class="title-container">
      <h2>Assign projects for {{drawName}}</h2>
    </div>
    <div class="drawer-close" (click)="rightSideDrawerService.closeRightSideDrawer()">
      <i class="fas fa-times" aria-hidden="true"></i>
    </div>
  </header>
  <section class="sideRight-body">
    <table class="assign-projects-checklist" cellpadding="5" cellspacing="5">
      <tr>
        <div>
          If you cannot find any specific project here, please check if you have added them in
          <a routerLinkActive="active" (click)="navigateToProjectsAndAcrivities()" class="dataimport-link">Define
            Projects & Activities</a>.
        </div>
      </tr>
      <tr>
        <td>
          <div>
            <div class="input-with-icon table-filter">
              <input class="table-search-input search-box-custom" placeholder="Search projects by name or entity"
                  type="text"  id="searchtext" [value]="defaultentity"
                  (keyup)="searchDataTableFilter($event.target.value)" />
              <button type="text" id="clear-form" class="cross-icon"
                  (click)="resetDataTableFilter('')"></button>
              <i class="fa-solid fa-search" aria-hidden="true"></i>
            </div>
            <div class="show-activities-text lbltext">
              Showing {{projects?.length}} available projects; {{getSelectedProjectsCount()}} are selected
            </div>
          </div>
        </td>
      </tr>
      <tr *ngIf="projects && projects?.length!==0">
        <td>
          <label class="datatable-checkbox parent-checkbox kpmg-checkbox">
            <input type="checkbox" [checked]="selectAll" (change)="SelectAll($event)" /><span>Select All</span>

          </label>
        </td>
      </tr>
      <tr class="project" *ngFor="let project of projects; let i = index" [attr.data-index]="i">
        <td>
          <label class="datatable-checkbox child-checkbox  "
            [ngClass]="project.indeterminate ? 'projectchk' : 'kpmg-checkbox'">
            <input class="indeterminate-input" type="checkbox" [checked]="project.isSelected"
              [indeterminate]="project.indeterminate" (change)="SetProjects(project,$event,i)" /><span>
              {{project.projectName}} - {{project.qPercentage}}% Qualified</span>
          </label>
        </td>
      </tr>
    </table>
    <span class="d-flex justify-content-end">{{selectedProjects.length}} total projects selected</span>
  </section>
  <footer class="endFormSubmit info-tile">
    <button type='button' class="btn btn-success" [disabled]="isAddDisabled" (click)="SubmitProjects()">Add
      Selected</button>
    <button type='button' class="btn kpmg-button--flat"
      (click)="rightSideDrawerService.closeRightSideDrawer()">Cancel</button>
  </footer>
</form>
